import React from 'react';

import classes from './FlightInfoContainer.scss';

const flightInfoContainer = (props) => (
    <div className={classes.Outer}>
        <div className={`${classes.Inner} u-flex f-column justify-content-between u-height100Percent`}>
            {props.children}
        </div>
      </div>
);

export default flightInfoContainer;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoContainer/FlightInfoContainer.js